var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',_vm._b({attrs:{"open-delay":_vm.customOpenDelay},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"activator"},on),[_vm._t("activator")],2)]}}],null,true)},"v-tooltip",_vm._d({},[_vm.position,true])),[_c('div',{staticClass:"content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }